import React, { useEffect, useState } from "react";
import * as M from "../../style/StyleComponentMain";
import CustomerSummary from "./CustomerSummary";
import arrowForward from "../../assets/icons/arrow_forward_ios.svg"
import ReservationDetailSummary from "./ReservationDetailSummary";
import { useNavigate } from "react-router-dom";
import PointChargeSummary from "./PointChargeSummary";
import PortfolioSummary from "./PortfolioSummary";
import price_system from "../../assets/images/ablack_construction_price_system_240430.jpg";
import { useDispatch } from "react-redux";
import { reduxResetCommunity } from "../../redux/CommunitySlice";
import PopupNotice from "../About/PopupNotice";
import { get_day_timestamp } from "../../Validation";
import bannerImage from "../../assets/images/ablack_banner.jpg";

const Main: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [popup, setPopup] = useState<boolean>(false);

    const closePopup = () => {
        setPopup(false);
    };

    const handleNoPopupToday = () => {
        let now = new Date();
        let str = get_day_timestamp(now).year_month_day;
        localStorage.setItem("no_popup_today", str);
        setPopup(false);
    };

    const handleLink = (url:string) => {
        navigate(url);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        let no_popup_today = localStorage.getItem("no_popup_today");
        let now = new Date();
        if (get_day_timestamp(now).year_month_day === no_popup_today) {
            setPopup(false);
        } else {
            setPopup(true);
        }
    }, []);

    return (
        <>
            <M.MainContainer>
                <div className="max-w-[1320px] mx-auto">
                    <img 
                        className="w-full cursor-pointer"
                        src={`${bannerImage}`} 
                        alt="abalckBanner"
                        onClick={() => {
                            window.open('https://shop.ambience.kr');
                        }}
                    />
                    <div className="grid min-[1180px]:grid-cols-10 gap-5 mt-5 mx-auto">
                        <M.GridBox className="col-span-10 min-[1180px]:col-span-4">
                            <div className="main-section-title-box">
                                <h4>A.black 서비스 현황</h4>
                                <div className="main-section-showmore-box">
                                    <button onClick={() => navigate('/reservation_detail')}>더보기</button>
                                    <img src={arrowForward} alt="" />
                                </div>
                            </div>
                            <br />
                            <M.CustomerSummaryBox onClick={() => navigate('/reservation_detail')}>
                                <CustomerSummary />
                            </M.CustomerSummaryBox>
                            <div className="text-[14px] text-middleGray02 leading-[24px] mt-4">
                                <p>- 매칭 중 : 고객님의 스케줄과 일치하는 라이팅 인스톨러 매칭하는 상태</p>
                                <p>- 결제대기 : 서비스 결제가 완료되지 않은 상태</p>
                                <p>- 결제완료 : 서비스 결제가 완료된 상태</p>
                                <p>- 시공완료 : 모든 서비스가 완료된 상태</p>
                            </div>
                            <div className="text-center mt-4">
                                <button className="w-[100%] h-[45px] font-semibold border border-mainBlack bg-white text-mainBlack text-[16px] rounded-[8px] hover:bg-opacity-90 active:bg-opacity-80 hover:bg-gray-100 transition-all duration-200 cursor-pointer shadow-md hover:shadow-lg" onClick={() => handleLink('/reservation')}>A.Black 예약하기</button>
                            </div>
                        </M.GridBox>
                        <M.GridBox className="col-span-10 min-[1180px]:col-span-6">
                            <div className="main-section-title-box" style={{borderBottom : "0"}}>
                                <h4>예약 상세 내역</h4>
                                <div className="main-section-showmore-box" onClick={() => navigate('/reservation_detail')}>
                                    <button>더보기</button>
                                    <img src={arrowForward} alt="" />
                                </div>
                            </div>
                            <ReservationDetailSummary />
                        </M.GridBox>
                        <M.GridBox className="col-span-10 min-[1180px]:col-span-4">
                            <div className="main-section-title-box">
                                <div className="flex">
                                    <h4>
                                        AP 포인트 충전
                                        <span className="text-[14px] text-[#7B7D81] leading-[20px]"> (1 원 = 1 AP포인트)</span>
                                    </h4>
                                    <div>
                                        <span
                                            className="leading-[28px] ml-2 hover:underline cursor-pointer text-red-600"
                                            onClick={() => {
                                                window.open(price_system);
                                            }}
                                        >
                                            [설치비용 보기]
                                        </span>
                                    </div>
                                </div>
                                <div className="main-section-showmore-box">
                                    <button onClick={() => navigate('/point_charge')}>더보기</button>
                                    <img src={arrowForward} alt="" />
                                </div>
                            </div>
                            <PointChargeSummary />
                        </M.GridBox>
                        <M.GridBox className="col-span-10 min-[1180px]:col-span-6">
                            <div className="main-section-title-box mb-5">
                                <h4>시공 포트폴리오</h4>
                                <div className="main-section-showmore-box">
                                    <button 
                                        onClick={() => {
                                            dispatch(reduxResetCommunity());
                                            navigate('/community');
                                        }}
                                    >
                                        더보기
                                    </button>
                                    <img src={arrowForward} alt="" />
                                </div>
                            </div>
                            <PortfolioSummary />
                        </M.GridBox>
                    </div>
                </div>
            </M.MainContainer>
            {popup &&
                <PopupNotice 
                    closePopup={closePopup}
                    handleNoPopupToday={handleNoPopupToday}
                />
            }
        </>
    )
};

export default Main;